/**
 * @description: Parcelforce overlay.
 * @requires {Object} configService
 * @requires {Object} overlayService
 * @requires {Object} $rootScope
 */
function pfwOverlayController(overlayService, configService, $rootScope) {

  const vm = this;
  vm.pfwTrackingNumber = overlayService.getPfwTrackingNumber;
  vm.overlayGetter = overlayService.getPfwOverlayState();
  vm.overlayHeading = configService.messages.pfw.overlay_heading;
  vm.overlayText = configService.messages.pfw.overlay_text;
  vm.overlayButton = configService.messages.button.close;
  vm.pfwLink = configService.links.limited_history_pfw;
  vm.pfwWebsite = configService.messages.pfw.overlay_website;
  vm.overlayToggle = () => {

    overlayService.togglePfwOverlay();
    $rootScope.$broadcast('overlayClosed');

  };

  // Here to avoid loosing state when returning to the trackingcode page
  angular.element(document).ready(() => {

    const overlay = document.getElementById('overlay');
    angular.element(document.body).append(overlay);

  });

}

export default pfwOverlayController;



// WEBPACK FOOTER //
// ./src/components/pfwOverlay/pfwOverlay.controller.js